export const categories = [
    {
        "name": "Categorie 1"
    },
    {
        "name": "Categorie 2"
    },
    {
        "name": "Categorie 3"
    },
    {
        "name": "Categorie 4"
    },
    {
        "name": "Categorie 5"
    },
    {
        "name": "Categorie 6"
    },
    {
        "name": "Categorie 7"
    },
]